import FormSection from 'components/Control/Form/FormSection'
import {generalSettings} from 'constants/FormField/settings'
import React from 'react'
import {useFormContext} from 'react-hook-form'

const GeneralSettings = () => {
    const methods = useFormContext()

    return (
        <FormSection
            fields={generalSettings}
            methods={methods}
            i18nCategory={'settings.generalSettings'}
        />
    )
}

export default GeneralSettings
